"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _system = require("@mui/system");
var _theme = require("../../../../theme");
var _DividerLine = require("../../../../components/DividerLine");
var _HeaderBar = require("../../../../components/HeaderBar");
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _sbUtils = require("@simplybenefits/sb-utils");
var _BenefitPremiumRow = _interopRequireDefault(require("./../components/BenefitPremiumRow"));
var _i18n = _interopRequireDefault(require("../../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../../localization/tokens"));
var Block = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  paddingRight: 10
});
var Row = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  padding: "5px 8px"
});

/**
 *
 * @param overallSummary
 * @returns {number}
 * @private
 */
function _calculatePremiumTotal(overallSummary) {
  var result = overallSummary.totals.premium + (overallSummary.totals.GST || 0) + (overallSummary.totals.HST || 0) + (overallSummary.totals.RST || 0) + (overallSummary.totals.PST || 0) - (overallSummary.totals.adjustments.GST || 0) - (overallSummary.totals.adjustments.HST || 0) - (overallSummary.totals.adjustments.RST || 0) - (overallSummary.totals.adjustments.PST || 0);

  // ASO Arrears Float Charge
  if (overallSummary.totals.asoArrearsFloatCharge && overallSummary.totals.asoArrearsFloatCharge !== 0) {
    result += overallSummary.totals.asoArrearsFloatCharge;
  }

  // Spending Account Float Charge
  if (overallSummary.totals.spendingAccountFloatCharge && overallSummary.totals.spendingAccountFloatCharge !== 0) {
    result += overallSummary.totals.spendingAccountFloatCharge;
  }

  // ASO Adjustments
  if (overallSummary.totals.asoAdjustments !== 0) {
    result += overallSummary.totals.asoAdjustments;
  }
  return result;
}

/**
 *
 * @param overallSummary
 * @returns {*}
 * @private
 */
function _calculateTotalAdjustments(overallSummary) {
  return overallSummary.totals.adjustments instanceof Object ? overallSummary.totals.adjustments.total : overallSummary.totals.adjustments;
}

/**
 *
 * @param overallSummary
 * @returns {number}
 * @private
 */
function _calculateTotalDue(overallSummary) {
  return _calculatePremiumTotal(overallSummary) + _calculateTotalAdjustments(overallSummary);
}

/**
 *
 * @param {*} param0
 * @returns
 */
var BenefitPremiums = function BenefitPremiums(_ref) {
  var account = _ref.account,
    overallSummary = _ref.overallSummary;
  return /*#__PURE__*/_react["default"].createElement(Block, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    largest: true,
    bold: true,
    customStyle: {
      marginTop: 50
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.benefitPremiums)), /*#__PURE__*/_react["default"].createElement(_HeaderBar.HeaderBar, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 2
    }
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.volume)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.total)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.adjustments)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    color: _theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.current))), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.lifeInsurance),
    benefit: overallSummary.life
  }), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.accidentalDeathAndDismemberment),
    benefit: overallSummary.add
  }), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.longTermDisability),
    benefit: overallSummary.ltd
  }), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.shortTermDisability),
    benefit: overallSummary.std
  }), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.dependentLife),
    benefit: overallSummary.depLife
  }), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.criticalIllness),
    benefit: overallSummary.ci
  }), overallSummary.ciSpouse && overallSummary.ciSpouse.volume > 0 && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllnessSpouse)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, overallSummary.ciSpouse.volume), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.ciSpouse.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.ciSpouse.adjustments instanceof Object ? overallSummary.ciSpouse.adjustments.net : overallSummary.ciSpouse.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.ciSpouse.premium + (overallSummary.ciSpouse.adjustments instanceof Object ? overallSummary.ciSpouse.adjustments.net : overallSummary.ciSpouse.adjustments), 2, true))), overallSummary.ciChild && overallSummary.ciChild.volume > 0 && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.criticalIllnessChild)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, overallSummary.ciChild.volume), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.ciChild.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.ciChild.adjustments instanceof Object ? overallSummary.ciChild.adjustments.net : overallSummary.ciChild.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.ciChild.premium + (overallSummary.ciChild.adjustments instanceof Object ? overallSummary.ciChild.adjustments.net : overallSummary.ciChild.adjustments), 2, true))), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.health),
    benefit: overallSummary.health
  }), Boolean(overallSummary.outOfCountry && (overallSummary.outOfCountry.premium || (overallSummary.outOfCountry.adjustments instanceof Object ? overallSummary.outOfCountry.adjustments.net : overallSummary.outOfCountry.adjustments))) && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.outOfCountry)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, overallSummary.outOfCountry.solo.volume + overallSummary.outOfCountry.duo.volume + overallSummary.outOfCountry.family.volume), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.outOfCountry.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.outOfCountry.adjustments instanceof Object ? overallSummary.outOfCountry.adjustments.net : overallSummary.outOfCountry.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.outOfCountry.premium + (overallSummary.outOfCountry.adjustments instanceof Object ? overallSummary.outOfCountry.adjustments.net : overallSummary.outOfCountry.adjustments), 2, true))), Boolean(overallSummary.stopLoss && (overallSummary.stopLoss.premium || (overallSummary.stopLoss.adjustments instanceof Object ? overallSummary.stopLoss.adjustments.net : overallSummary.stopLoss.adjustments))) && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.stopLoss)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, overallSummary.stopLoss.solo.volume + overallSummary.stopLoss.duo.volume + overallSummary.stopLoss.family.volume), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.stopLoss.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.stopLoss.adjustments instanceof Object ? overallSummary.stopLoss.adjustments.net : overallSummary.stopLoss.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.stopLoss.premium + (overallSummary.stopLoss.adjustments instanceof Object ? overallSummary.stopLoss.adjustments.net : overallSummary.stopLoss.adjustments), 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.hsa)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.numberWithCommas((overallSummary.hsa.solo.volume + overallSummary.hsa.duo.volume + overallSummary.hsa.family.volume).toFixed(2))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.hsa.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.hsa.adjustments instanceof Object ? overallSummary.hsa.adjustments.net : overallSummary.hsa.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.hsa.premium + (overallSummary.hsa.adjustments instanceof Object ? overallSummary.hsa.adjustments.net : overallSummary.hsa.adjustments), 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.lsa)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.numberWithCommas((overallSummary.lsa.solo.volume + overallSummary.lsa.duo.volume + overallSummary.lsa.family.volume).toFixed(2))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.lsa.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.lsa.adjustments instanceof Object ? overallSummary.lsa.adjustments.net : overallSummary.lsa.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.lsa.premium + (overallSummary.lsa.adjustments instanceof Object ? overallSummary.lsa.adjustments.net : overallSummary.lsa.adjustments), 2, true))), overallSummary.costPlus && overallSummary.costPlus.premium > 0 && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].titles.costPlus)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.numberWithCommas(overallSummary.costPlus.volume.toFixed(2))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.costPlus.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.costPlus.adjustments instanceof Object ? overallSummary.costPlus.adjustments.net : overallSummary.costPlus.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.costPlus.premium + (overallSummary.costPlus.adjustments instanceof Object ? overallSummary.costPlus.adjustments.net : overallSummary.costPlus.adjustments), 2, true))), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.efap),
    benefit: overallSummary.efap
  }), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.virtualHealthCare),
    benefit: overallSummary.virtualHealthcare
  }), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.financialAwareness),
    benefit: overallSummary.financialAwareness
  }), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.dental),
    benefit: overallSummary.dental
  }), Boolean(account.isAsoHealth === 1 || account.isAsoDental) && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.asoBalanceAdjustment)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.asoAdjustments || 0, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.asoAdjustments || 0, 2, true))), /*#__PURE__*/_react["default"].createElement(_BenefitPremiumRow["default"], {
    title: _i18n["default"].t(_tokens["default"].titles.optionalBenefits),
    benefit: overallSummary.optionalBenefits
  }), overallSummary.miscPremiums && overallSummary.miscPremiums.types && Object.keys(overallSummary.miscPremiums.types).length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DividerLine.DividerLine, null), Object.keys(overallSummary.miscPremiums.types).map(function (type) {
    var record = overallSummary.miscPremiums.types[type];
    return /*#__PURE__*/_react["default"].createElement(Row, {
      key: type
    }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      small: true,
      bold: true,
      customStyle: {
        flex: 2
      }
    }, type), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, _sbUtils.helpers.numberWithCommas(record.volume)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, _sbUtils.helpers.formatNumber(record.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      small: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      small: true,
      bold: true,
      customStyle: {
        flex: 1,
        textAlign: 'center'
      }
    }, _sbUtils.helpers.formatNumber(record.premium, 2, true)));
  }), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, "Total"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.numberWithCommas(overallSummary.miscPremiums.volume)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.miscPremiums.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.miscPremiums.adjustments instanceof Object ? overallSummary.miscPremiums.adjustments.net : overallSummary.miscPremiums.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.miscPremiums.premium + (overallSummary.miscPremiums.adjustments instanceof Object ? overallSummary.miscPremiums.adjustments.net : overallSummary.miscPremiums.adjustments), 2, true)))) : /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.miscPremiums)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.numberWithCommas(overallSummary.miscPremiums.volume)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.miscPremiums.premium, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.miscPremiums.adjustments instanceof Object ? overallSummary.miscPremiums.adjustments.net : overallSummary.miscPremiums.adjustments, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.miscPremiums.premium + (overallSummary.miscPremiums.adjustments instanceof Object ? overallSummary.miscPremiums.adjustments.net : overallSummary.miscPremiums.adjustments), 2, true))), Boolean(overallSummary.totals.spendingAccountFloatCharge && overallSummary.totals.spendingAccountFloatCharge !== 0) && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.spendingFloat)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.spendingAccountFloatCharge, 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.spendingAccountFloatCharge, 2, true))), Boolean(overallSummary.totals.asoArrearsFloatCharge && overallSummary.totals.asoArrearsFloatCharge !== 0) && /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.asoFloat)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.asoArrearsFloatCharge, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.asoArrearsFloatCharge, true))), /*#__PURE__*/_react["default"].createElement(_DividerLine.DividerLine, null), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.pst)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.PST + (overallSummary.totals.RST || 0) - (overallSummary.totals.adjustments.PST || 0) - (overallSummary.totals.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber((overallSummary.totals.adjustments.PST || 0) + (overallSummary.totals.adjustments.RST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(overallSummary.totals.PST + (overallSummary.totals.RST || 0), 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.gstHst)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber((overallSummary.totals.HST || 0) + (overallSummary.totals.GST || 0) - (overallSummary.totals.adjustments.HST || 0) - (overallSummary.totals.adjustments.GST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber((overallSummary.totals.adjustments.HST || 0) + (overallSummary.totals.adjustments.GST || 0), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    small: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber((overallSummary.totals.HST || 0) + (overallSummary.totals.GST || 0), 2, true))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 2
    }
  }, _i18n["default"].t(_tokens["default"].labels.invoices.totalDue)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, "-"), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(_calculatePremiumTotal(overallSummary), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(_calculateTotalAdjustments(overallSummary), 2, true)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _sbUtils.helpers.formatNumber(_calculateTotalDue(overallSummary), 2, true))));
};
var _default = exports["default"] = BenefitPremiums;